// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8fead4e6","977":"0a372db7"}[chunkId] + ".chunk.js";
};